export type IsInertOptions = {
  /**
   * Include inert elements set by UW when opening the widget
   */
  includeUWInert?: boolean;
};

export const IsInertOptions: IsInertOptions = {
  includeUWInert: false,
};

/**
 * Determines whether the given element or any of its ancestors (up to <html>)
 * has the `inert` attribute, indicating it is not interactive.
 */
export const isInertElement = (
  element: Element,
  options = IsInertOptions,
): boolean => {
  const { includeUWInert } = options;

  if (includeUWInert) {
    return element.closest('[inert]') !== null;
  }

  return element.closest('[inert]:not([data-uw-inert])') !== null;
};
